const uuid = require('uuid');
const getWapb3ForRedirection = require('./config/expedia_redirection_wapb3');

const brandsFullName = {
    ED: 'edreams',
    OP: 'opodo',
    GV: 'govoyages',
    TL: 'travellink',
};

const primeBrandsWidgetIDs = {
    ED: '125',
    GV: '126',
    OP: '127',
    TL: '125', // currently there is no prime in TL. This value is just left as a fallback in case they activate these markets
};

const LABEL_REGEX = /(\|)(?!.*\|)(.*)/;
const WAPB3_PATTERN = 'wapb3=';
const AMPERSAND = '&';

const getUrlWihtoutWapb3 = (url, start, end) => {
    return url.slice(0, start) + url.slice(end + 1);
};

const getWapb3FromUrl = (url, start, end) => {
    return url.slice(start, end);
};

const findWapb3InUrl = (url) => {
    let wapb3StartingPosition;
    let wapb3EndingPosition;
    if (!Odigeo._.isEmpty(url)) {
        let startingPosition = url.indexOf(WAPB3_PATTERN);
        if (startingPosition !== -1) {
            wapb3StartingPosition = startingPosition;
            let endingPosition = url.indexOf(AMPERSAND, startingPosition + 1);
            if (endingPosition === -1) {
                wapb3EndingPosition = url.length;
            } else {
                wapb3EndingPosition = endingPosition;
            }
        }
    }
    return [wapb3StartingPosition, wapb3EndingPosition];
};

const formatWapb3ForAb = (wapb3, abInfo, touchpoint) => {
    return wapb3.replace(LABEL_REGEX, '|' + getWapb3ForRedirection(abInfo, touchpoint));
};

const getExpediaKey = function() {
    return Odigeo.CrossSelling.expedia.key;
};

module.exports = {
    replaceWapb3ForAb(url, touchpoint, abInfo) {
        if (abInfo !== 1) {
            let wapb3Positions = findWapb3InUrl(url);
            if (wapb3Positions[0] >= 0) {
                let wapb3 = getWapb3FromUrl(url, ...wapb3Positions);
                wapb3 = formatWapb3ForAb(wapb3, abInfo, touchpoint);
                let urlwithout = getUrlWihtoutWapb3(url, ...wapb3Positions);
                url = urlwithout + AMPERSAND + wapb3;
            }
        }
        return url;
    },

    getMemberDiscountParams(isPrime=false) {
        let brandName = brandsFullName[Odigeo._.get(Odigeo, 'SessionScope.brand')];

        return isPrime ? {rffrid: `h4p.hcom.${brandName}prime.000.000`, intlid: uuid.v4()} : {};
    },

    getToken(data) {
        return import('crypto').then(
            ({default: crypto}) => {
                return crypto.createHmac('sha256', getExpediaKey())
                    .update(data)
                    .digest('hex');
            });
    },

    getExpediaWidgetId(isPrime) {
        return isPrime ? primeBrandsWidgetIDs[Odigeo.SessionScope.brand] : Odigeo.CrossSelling.expedia.id;
    },
};
